// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* eslint-disable design-system/ensure-design-token-usage */
/* stylelint-disable design-system/ensure-design-token-usage */
/* we are purposely not using design tokens, since we do not want the modal to change
for light vs. dark mode */
.GwVcQhX8Ln7Ncb {
  background: rgba(0, 0, 0, 0.5);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `GwVcQhX8Ln7Ncb`
};
export default ___CSS_LOADER_EXPORT___;
